{
    "LANGUAGES": {
        "EN": "English",
        "AR": "عربي"
    },
    "THEME": {
        "DARK": "Dark",
        "LIGHT": "Light"
    },
    "PHRASES": {
        "OR": "Or",
        "ALL": "All",
        "WELCOME": "Welcome",
        "WELCOME_MSG": "Dear {{name}}, Welcome To GLobal Star Rating Platform, You Are Logged In As {{role}}",
        "WELCOME_ENTITY": "for {{entity}}",
        "WELCOME_ORDER": "Check the side menu to move forward",
        "NO_RECORDS": "No records found",
        "NO_OPTIONS": "No options found",
        "DETAILS": "Details",
        "SUCCESS_MSG": "Done successfully",
        "CHAR_LEFT": "character left",
        "BONUS": "Inc. Bonus",
        "PAGE": "Page",
        "OF": "Of",
        "TOTAL": "Total",
        "WARNING": "Warning"
    },
    "PLATFORMS": {
        "GSR": "Global Star Rating System"
    },
    "ACTIONS": {
        "ACTIONS": "Actions",
        "CONFIRM": "Confirm",
        "SUBMIT": "Submit",
        "CANCEL": "Cancel",
        "YES": "Yes",
        "NO": "No",
        "CLOSE": "Close",
        "LOGIN": "Sign in",
        "REGISTER": "Register to be assessor",
        "REG": "Register",
        "REG_NOW": "Register as assessor",
        "RESET_PASS": "Reset Password",
        "LOGOUT": "Log Out",
        "EDIT": "Edit",
        "SEARCH": "Search",
        "SAVE": "Save",
        "SAVE_NOTIFY": "Save & Notify",
        "FORGOT_PASSWORD": "Forgot your password?",
        "DELETE": "Delete",
        "DELETE_USER": "delete user",
        "DELETE_ITEM": "delete item",
        "ADD_USER": "Add User",
        "ADD_CYCLE": "Add Cycle",
        "EDIT_PROFILE": "Account Management",
        "CHANGE_PASSWORD": "Change Password",
        "CONFIRMATION": "Are you sure you want to",
        "START_CYCLE_CONFIRM": "You can't change questions/upload doc once its started",
        "SELECT_ALL": "Select All",
        "MANAGE": "Manage",
        "CLONE": "Clone",
        "DEADLINS": "Deadlines",
        "REVIEW": "Review",
        "PREVIEW": "Review Self Assessment",
        "ANSWER": "Answer",
        "ACCEPT": "Accept",
        "REJECT": "Reject",
        "NEXT": "Next",
        "BACK": "Back",
        "ADD": "Add",
        "calc": "Calculate",
        "ASSIGN": "Assign",
        "LINK_TO_UAEPASS": "Link Account with UAE PASS",
        "REMOVE_UAEPASS": "Remove UAE PASS",
        "LINK_ACCOUNT": "Link Account"
    },
    "DASHBOARD": {
        "UPLOAD_DOC": "Upload Documents",
        "ANSWERS": "Answers",
        "ASSESSMENTS": "Assessments",
        "TOP_ASSESSORS": "Top Assessors",
        "ASSESSORS": "Assessors",
        "CYCLES": "Cycles",
        "NEW": "New",
        "ACTIVE": "Active",
        "NEAR_DEADLINE": "Near Deadlines",
        "ENTITY_USERS": "Entity Users",
        "TOTAL": "Total",
        "APPROVED": "Approved",
        "PENDING": "Pending Review",
        "REJECTED": "Rejected",
        "CLOSED": "Closed",
        "OPEN": "Open",
        "PENDING_ADMIN_ACTION": "Pending Admin Action",
        "PENDING_USER_ACTION": "Pending User Action",
        "ASSESSOR_SIGNUP": "Assessor Signup",
        "ASSESSOR_APPROVED": "Assessor Approved",
        "ASSESSOR_REJECTED": "Assessor Rejected",
        "ANSWER_APPREOVED": "Answers Approved",
        "ANSWER_REJECTED": "Answers Rejected",
        "COMPLETED_CYCLES": "Completed Cycles",
        "PUPLISHED_CYCLES": "Puplished Cycles",
        "OWN_CYCLE_PUPLISHED": "In Puplished Cycle"
    },
    "ASSESSMENT_ACTIONS": {
        "SELF_ASSESSMENT_VIEW": "View Self Assessment",
        "SELF_ASSESSMENT_ANSWER": "Answer Self Assessment",
        "ASSESSOR_ASSESSMENT_VIEW": "View Assessor Assessment",
        "ASSESSOR_ASSESSMENT_REVIEW": "Review Assessor Assessment",
        "ASSESSOR_ASSESSMENT_ANSWER": "Answer Assessor Assessment",
        "ASSESSMENT_VIEW": "View Assessment",
        "ASSESSMENT_REVIEW": "Review Assessment",
        "ASSESSMENT_ANSWER": "Answer Assessment",
        "ASSESSMENT_REPORT": "Assessment Report",
        "ENTITY_DOCUMENT_REVIEW": "Review Entity Documents",
        "DOCUMENTS_UPLOAD": "Upload documents",
        "MANAG_DOC": "Manage Documents",
        "REVIEW_DOCS": "Review Documents",
        "MANAG_EXTRA_DOC": "Manage Extra Documents",
        "REVIEW_EXTRA_DOCS": "Review Extra Documents"
    },
    "USER_FORM": {
        "EMAIL": "Email",
        "EMIRATES_ID": "Emirates Id",
        "PASSWORD": "Password",
        "FIRST_NAME": "First Name",
        "MIDDLE_NAME": "Middle Name",
        "LAST_NAME": "Last Name",
        "FULL_NAME": "Full Name",
        "CURRENT_PASS": "Current Password",
        "NEW_PASS": "New Password",
        "CONFIRM_PASS": "Confirm Password",
        "CV": "CV",
        "PROFILE_PIC": "Edit Profile Picture",
        "DELETE_PROFILE_PIC": "Delete Profile Pic",
        "UPLOAD": "Upload Your CV",
        "UPLOAD_FILES": "Upload Files",
        "OPTIONAL": "Optional",
        "SUBMITTED": "Registration completed successfully, your application is currently under review",
        "PASSWORD_RESET_SUCCESS": "Your Password has been successfully reset, a link has been sent to your email to create a new password",
        "PASSWORD_RESET_CONFIRM": "Password changed successfully, please login with your new password",
        "STATUS": "Status",
        "REGISTER_COMPLETE": "Sign Up Completed",
        "ROLE": "Role",
        "DRAG_DROP_HINT": "Drag and drop file here",
        "UPLOAD_HINT": "(.pdf) Max Size: 10MB",
        "UPLOAD_HINT_20": "(.pdf) Max Size: 20MB",
        "NAME": "Name",
        "ENTITY": "Entity",
        "ENTITY_TYPE": "Entity Type",
        "ENTITY_LEVEL": "Entity Level",
        "SERVICE_CHANNEL_TYPE": "Service Channel Type",
        "CHANNELS_TYPE": "Channels Type",
        "SERVICE_CHANNEL": "Service Channel",
        "SUPPORT_DOC": "Supporting Documents",
        "ADD_DOC": "Add Document",
        "EDIT_DOC": "Edit Document",
        "DELETE_DOC": "Delete Document",
        "DOC_HINT": "2 docs max. Max Size: 10MB",
        "DOC": "Doc",
        "VIEW_DOCS": "View Documents",
        "NO_DOC": "No Document Found",
        "REGISTERED_FROM": "Registered From",
        "REGISTERED_TO": "Registered To",
        "REGISTRATION_DATE": "Registration Date",
        "AVATAR": "Avatar"
    },
    "CYCLES_FORM": {
        "LABEL": "Name",
        "AR_NAME": "Name in Arabic",
        "EN_NAME": "Name in English",
        "ENTITIES": "Entities",
        "CHANNELS": "Service channels",
        "CHANNEL": "Service channel",
        "SERVICES": "Services",
        "SERVICE_CENTER": "Service Center",
        "APPLICATION": "Application",
        "CALL_CENTER": "Call Center",
        "WEBSITE": "Website",
        "GENERAL_STATISTICS": "General Statistics",
        "UPLOAD_DOC_DEADLINE": "Upload Documents Deadline",
        "EXTRA_DOC_DEADLINE": "Extra Documents Deadline",
        "ASSESSMENT_COMPLETE_DEADLINE": "Assessment Complete Deadline",
        "ALL_SERVICE_CHANNELS": "All service channels",
        "ALL_SUB_SERVICES": "All sub services",
        "KHADAMATI": "Khadamati",
        "EDITED_AT": "Edit At",
        "CALC_BY": "Calculated By",
        "ASSIGN_BY": "Assigned By",
        "NO_CALCULATION": "No Caculations yet",
        "NO_EXTRA_DOC": "No Extra Documents Yet"
    },
    "ASSESSORS": {
        "TITLE": "Assessors",
        "DETAILS": "Assessor Details",
        "SEARCH_ASSESSOR": "Search Assessors"
    },
    "USERS": {
        "TITLE": "Users",
        "DETAILS": "User Details"
    },
    "CYCLES": {
        "TITLE": "Cycles",
        "DETAILS": "Cycle Details",
        "MANAGE_DEADLINES": "Manage Deadlines",
        "EDIT_CYCLE": "Edit Cycle",
        "CLONE_CYCLE": "Clone Cycle",
        "RUN_CYCLE": "Run Cycle",
        "DISCARD_CYCLE": "Discard Cycle",
        "COMPLETE_CYCLE": "Complete Cycle",
        "MANAGE_ASSESSMENT": "Manage Assessment",
        "MANAGE_QUESTIONS": "Manage Questions",
        "MANAGE_PILLARS": "Manage Pillars",
        "MANAGE_UPLOADED_DOCUMENTS": "Manage Documents Upload",
        "MANAGE_STATUS": "Manage Status",
        "ASSIGN_ASSESSOR": "Assign Assessors",
        "SCORING": "Scoring",
        "RESULT": "Results",
        "CONFIG": "Configuration",
        "CALC": "Calculation",
        "OVERALL_SCORE": "Overall Score",
        "GOV_AVG": "Government Avg",
        "PILLARS_SCORE": "Assessment Pillars Score",
        "CHANNELS_OVERALL_SCORE": "Channels Average Score",
        "SERVICE_CHANNELS_SCORE": "Service Channels Score",
        "ENTITIES_SCORE": "Entities Score",
        "PER_ENTITY_SCORE": "Entities Score",
        "BEST_ENTITIES": "Best Entities",
        "PER_CHANNEL_SCORE": "Per Channel Score",
        "ASSESSMENT_SCORING": "Assessment Scoring",
        "EC_SCORING": "External Sources Scoring",
        "CYCLE_EDIT_MSG": "You can edit cycle details by click on the button below to go to Manage Cycle page.",
        "MANAGE_DEADLINES_MSG": "You can manage cycle deadlines by click on the button below to go to Manage Deadlines page.",
        "MANAGE_ASSESSMENT_MSG": "You can add and manage assessment questions and pillars in Manage Assessment page by click on the button below.",
        "MANAGE_UPLOADED_DOCUMENTS_MSG": "You can manage documents upload in Manage Documents page by click on the button below.",
        "MANAGE_STATUS_MSG": "You can change the cycle status by click on the run cycle button or close button below.",
        "ASSIGN_ASSESSOR_MSG": "You can assign assessors to entities in assign assessors page.",
        "CONFIG_ASSESSOR_MSG": "You can manage configuration values in manage configuration page.",
        "SCORING_MSG": "You can manage the pillars weights and questions priorities by click on the buttons below.",
        "EC_SCORING_MSG": "You can manage the external sources weights by click on the buttons below.",
        "CALC_MSG": "You can manage cycle calculation by click on the calculation below.",
        "NO_MANAGE_ASSESSMENT_MSG": "You can't add and manage assessment questions and pillars once the cycle has started.",
        "NO_MANAGE_UPLOADED_DOCUMENTS_MSG": "You can't manage documents upload once the cycle has started.",
        "NOT_VALID_RUNCYCLE_MSG": "You can not start the cycle before complete manage all pillars and the assessment/upload documents questions.",
        "CYCLE_CLONE_MSG": "You will create a new cycle based on: {{cycle}}.All Questions from the existing cycles channels will be copied",
        "NO_KHADAMATI_ITEMS": "No khadamati Objects Matching.",
        "PENDING_START_CYCLE": "Pending starting the cycle"
    },
    "CYCLE_CONFIG": {
        "TITLE": "Cycle Configuration",
        "NO_EVIDENCE_W": "No evidence weight",
        "SOME_EVIDENCE_W": "Some evidence weight",
        "GOOD_EVIDENCE_W": "Good evidence weight",
        "OUTSTANDING_EVIDENCE_W": "Outstanding evidence weight",
        "ONE_PRIORITY_QUES_W": "Priority question weight one",
        "TWO_PRIORITY_QUES_W": "Priority question weight two",
        "THREE_PRIORITY_QUES_W": "Priority question weight three",
        "FOUR_PRIORITY_QUES_W": "Priority question weight four",
        "EVIDENCE_W": "Evidence weight",
        "QUES_W": "Question weight",
        "SOURCES_W": "Sources Weights",
        "SOURCES": "Sources",
        "ASSESSMENT_W": "Assessment Weights",
        "CHANNEL_OVERALL_W": "Channel Overall Weight",
        "STARS": "Stars",
        "STARS_RANGE": "Stars Ranges",
        "UNRATED_STAR": "Unrated Stars",
        "TWO_STAR": "Two Stars",
        "THREE_STAR": "Three stars",
        "FOUR_STAR": "Four Stars",
        "FIVE_STAR": "Five Stars",
        "SIX_STAR": "Six Stars",
        "SEVEN_STAR": "Seven Stars",
        "EXTERNAL_ENTITIES": "External Sources",
        "NO_EXTERNAL_ENTITIES": "No External Sources",
        "WEIGHT": "Weight",
        "MULTIPLIER": "Multiplier",
        "SCORE": "Score",
        "AVG_SCORE": "Avg Score",
        "CYCLE_AVG_SCORE": "Cycle Avg Score",
        "LOW_SCORE": "0-35%",
        "MED1_SCORE": "36-60%",
        "MED2_SCORE": "61-80%",
        "HIGH_SCORE": "81-100%",
        "CYCLE_AVG": "Cycle Avg",
        "NO_SCORE": "No Score",
        "PROGRESS": "Progress",
        "GSR_ASSESSMENT": "Global Stars Rating Assessment",
        "PILLARS_W": "GSR Pillars Breakdown Weight"
    },
    "DOCUMENTS": {
        "TITLE": "Documents",
        "PENDING_ANSWER": "Pending Reply"
    },
    "ACCOUNT": {
        "ACCOUNT": "Account"
    },
    "CYCLE_STATUS": {
        "PUBLISHED": "Published",
        "DRAFT": "Draft",
        "COMPLETED": "Completed",
        "DISCARDED": "Discarded"
    },
    "ASSESSMENT_FORM": {
        "TITLE": "Assessments",
        "NEW": "Add Assessment",
        "NAME": "Assessment Name",
        "NEW_UPLOAD_DOC": "Add Upload Document",
        "UPLOAD_DOC_STATUS": "Upload Document Status",
        "NEW_QUES": "Add Question",
        "DELETE_QUES": "Delete Question",
        "QUES_TEXT": "Question Text",
        "MATURITY_STAGES": "Maturity Stages",
        "INITIAL": "Initial",
        "EVOLUTION": "Evolution",
        "MATURITY": "Maturity",
        "LEADERSHIP": "Leadership",
        "EVIDENCE_STRINGTH": "Evidence Strength",
        "PRIORITY": "Question Priority",
        "QUES_TYPE": "Question Type",
        "UPLOAD": "Upload File",
        "ADDITIONAL_DOC": "Additional Documents",
        "CYCLE": "Cycle",
        "MATURITY_1_TITLE": "Inital",
        "MATURITY_2_TITLE": "Development",
        "MATURITY_3_TITLE": "Maturity",
        "MATURITY_4_TITLE": "Leading",
        "EVIDENCE_STRINGTH_1": "No Evidence",
        "EVIDENCE_STRINGTH_2": "There is Some Evidence",
        "EVIDENCE_STRINGTH_3": "Good Evidence",
        "EVIDENCE_STRINGTH_4": "Perfect Evidence",
        "NO_ANSWER": "No Answer",
        "NOT_APPLICABLE": "Not Applicable",
        "COMMENT": "Commentary",
        "ASSESSOR_COMMENT": "Assessor Commentary",
        "ENTITY_COMMENT": "Entity Commentary",
        "REPORT": "Report",
        "MAIN_REPORT": "Executive Summary",
        "SUB_REPORT": "Strengths and Opportunities for Improvement",
        "REPORT_TEXT": "Report Text",
        "STRENGTH_TEXT": "Strength Text",
        "WEAKNESS_TEXT": "Weakness Text",
        "APPROVED_Q": "Approved Questions",
        "ANSWERED": "Answered",
        "APPROVED": "Approved",
        "NO_REPORT": "No Report"
    },
    "ASSESSMENT_STATUS": {
        "PENDING": "Pending Review",
        "VIEW": "View",
        "ANSWER": "Answering",
        "REVIEW": "Review"
    },
    "PILLAR_FORM": {
        "TITLE": "Pillars Details",
        "ADD": "Add Pillar",
        "ADD_SUB": "Add Subpillar",
        "ADD_SUBJ": "Add Subject",
        "SELECT_PILLAR_MSG": "Please Select Pillar to manage its questions.",
        "MANAGE": "Manage",
        "ALL": "Pillars",
        "LEVEL1": "Pillar",
        "LEVEL2": "Sub Pillar",
        "LEVEL3": "Subject"
    },
    "MAT_PAGINATOR": {
        "OF": "of",
        "FIRST_PAGE": "First page",
        "ITEMS_PER_PAGE": "Items per page",
        "LAST_PAGE": "Last Page",
        "NEXT_PAGE": "Next Page",
        "PREVIOUS_PAGE": "Previous page"
    },
    "UAE_PASS": {
        "EXISTED_ACCOUNT_TITLE": "UAE PASS - GSR Profile Linking",
        "EXISTED_ACCOUNT_MSG": "Do you have an online account with GSR",
        "GSR_LOGIN": "Login with your GSR credentials",
        "EXISTED_ACCOUNT_NOTE": "Your UAE PASS account will be linked to your existing GSR profile",
        "NO_EXISTED_ACCOUNT_NOTE": "Your GSR profile will be established based on UAE PASS account",
        "NO_EXISTED_ACCOUNT_QUES": "Don't have an account?",
        "ONE_TIME_PROCESS_NOTE": "Note: This is one time process, your future login through UAE PASS will be seamless"
    },
    "ERRORS": {
        "invalid_request": "User cancelled the login",
        "login_required": "User cancelled the login",
        "access_denied": "User cancelled the login",
        "cancelledOnApp": "User cancelled the login",
        "UauPass_RespError": "Something went wrong during the login, please try again later!",
        "SOP1UserTypeError": "You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact {{name}} to access the services",
        "SOP2UserTypeError": "Please upgrade your account following instructions in the UAE PASS application",
        "UaePass_UserNotFoundError": "User was not found",
        "upload_file_conditions": "Icon file should be svg and under 50kb.",
        "upload_file_size_20MB": "File size should not be more than 20MB",
        "VALIDATION_ERROR": "Please fill the required fields",
        "UserNotActiveError": "This user is pending review or has been rejected. Please contact the support team for more information",
        "assessment_validation": "Make sure that required questions information are filled",
        "upload_file_wrong_extension": "Wrong file type."
    }
}
